import React, { useState } from "react";
import { SafText, SafIcon } from "@saffron/core-components/react";
import { Breadcrumb } from "..";
import "../../css/breadcrumb.css";
import "../../css/common.css";

const CustomHeader = ({ headingText, assetId, archVersion, headerDesc }) => {
  const [showDescription, setShowDescription] = useState(false);

  return (
    <div style={{ marginTop: "50px" }}>
      <Breadcrumb assetId={assetId} />
      <div className="custom-header">
        <SafText appearance="heading-xl" style={{ color: " #00233D" }}>
          {headingText}
        </SafText>
        {headerDesc && (
          <SafIcon
            icon-name="info-circle"
            appearance="solid"
            style={{ cursor: "pointer", fontSize: 18, color: "#c1babaff" }}
            onMouseOver={() => setShowDescription(true)}
            onMouseOut={() => setShowDescription(false)}
            aria-label="Show description"
            tabIndex={0}
          />
        )}
        {showDescription && (
          <div className="show-description" style={{ margin: "20px" }}>
            <div style={{ flex: 1, paddingRight: 16 }}>
              <SafText appearance="body-default-sm">{headerDesc}</SafText>
            </div>
            <SafIcon
              icon-name="xmark"
              appearance="solid"
              style={{
                cursor: "pointer",
                fontSize: 20,
                color: "#484444ff",
                marginLeft: 8,
                marginTop: 2,
              }}
              onClick={() => setShowDescription(false)}
              aria-label="Close description"
              tabIndex={0}
            />
          </div>
        )}
        <br />
        <div style={{ display: "flex", margin: "1rem 0" }}>
          <SafText>
            <strong>Asset ID</strong>: &nbsp;&nbsp;
            <a
              href={`https://assets.int.thomsonreuters.com/Technology/Application/${assetId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {assetId}
            </a>
          </SafText>
          <SafText style={{ marginLeft: "2rem" }}>
            <strong>Architecture Version</strong>: {archVersion}
          </SafText>
        </div>
      </div>
    </div>
  );
};

export default CustomHeader;
